export const changeWebsiteTitle = (isRtl: boolean) => {
  if (isRtl) document.title = 'رابطة الفكر العملي اللبنانية'
  else document.title = 'Lebanese Active Intellect Associations'
}
